import { createContext, useContext, ReactNode } from "react";
import { useCart as useCartHook, CartItem } from "@/hooks/useCart";

interface CartContextValue {
  cart: CartItem[];
  cartCount: number;
  loading: boolean;
  error: string | null;
  addToCart: (item: Omit<CartItem, 'id' | 'created_at' | 'updated_at'>) => Promise<void>;
  updateQuantity: (productId: string, quantity: number, size?: string, color?: string) => Promise<void>;
  removeFromCart: (productId: string, size?: string, color?: string) => Promise<void>;
  clearCart: () => Promise<void>;
  syncCart: () => Promise<void>;
}

const CartContext = createContext<CartContextValue | undefined>(undefined);

export function CartProvider({ children }: { children: ReactNode }) {
  const cart = useCartHook();

  return <CartContext.Provider value={cart}>{children}</CartContext.Provider>;
}

export function useCart() {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
}